import { api } from "./client";
import type { EquipmentInsight, TenantInsightsSummary } from "@/types";

export const insightsApi = {
  async equipment(id: string): Promise<EquipmentInsight> {
    const { data } = await api.get<EquipmentInsight>(`/equipments/${id}/insights`);
    return data;
  },
  async tenantSummary(tenantId: string): Promise<TenantInsightsSummary> {
    const { data } = await api.get<TenantInsightsSummary>(
      `/tenants/${tenantId}/insights/summary`,
    );
    return data;
  },
};
